<form [formGroup]="districtForm" class="objects-form mb-2" style="height:70vh; overflow-y: auto;"><!--(ngSubmit)="onSubmit()"-->
    <div class="shared-access-hint" *ngIf="!hasCrudRight">
        <mat-icon>info_outline</mat-icon>
        <span>{{ isCreate ? ('HD_not_allowed_create'|translate) : ('HD_not_allowed_edit'|translate) }}</span>
    </div>

    <div class="shared-access-hint" *ngIf="contextAccess !== 'owner'">
        <mat-icon>info_outline</mat-icon>
        <span *ngIf="isViewOnly">{{'HD_view_only' | translate}}</span>
        <span *ngIf="!isViewOnly">{{'HD_shared_info' | translate}}</span>
    </div>

    <div class="my-map-container" *ngIf="!!data.data" [class.geo-locked]="isGeoLocked">
        <app-map-info-display [object]="data.data" (onMapClick)="onMapClick()"></app-map-info-display>
    </div>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingDistrictForm.name' | translate}}</mat-label>
        <input formControlName="name" matInput type="text" required>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingDistrictForm.administrativeName' | translate}}</mat-label>
        <input formControlName="administrativeName" matInput type="text">
    </mat-form-field>
    <div>
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.huntingDistrictForm.state' | translate}}</mat-label>
            <mat-select formControlName="stateCode" >
                <mat-option *ngFor="let state of allStatesFiltered" [value]="state.isoCode" > {{state.translate | translate}} </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.huntingDistrictForm.country' | translate}}</mat-label>
            <mat-select formControlName="countryCode" >
                <mat-option *ngFor="let co of allCountries" [value]="co.isoCode" (click)="setStateOptions(co.id)"> {{co.translate | translate}} </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-form-field class="w-100" style="margin-bottom: 15px;">
        <mat-label>{{'FORM.huntingDistrictForm.veterinarianOffice' | translate}}</mat-label>
        <mat-select formControlName="veterinarianOfficeId" >
            <mat-option *ngFor="let vet of allVetAuthorities" [value]="vet.id" (click)="setOfficeName('veterinarianOffice',vet, vet.id, vet.name)">
                {{vet.name}}
            </mat-option>
        </mat-select>
        <mat-hint>
        {{ 'FORM.huntingDistrictForm.veterinaryOfficeHint' | translate }}
    </mat-hint>
    </mat-form-field>

    <mat-form-field class="w-100" style="margin-bottom: 15px;">
        <mat-label>{{'FORM.huntingDistrictForm.huntingOffice' | translate}}</mat-label>
        <mat-select formControlName="huntingOfficeId" >
            <mat-option *ngFor="let hunt of allHuntAuthorities" [value]="hunt.id" (click)="setOfficeName('huntingOffice',hunt, hunt.id, hunt.name)">
                {{hunt.name}}
            </mat-option>
        </mat-select>
        <mat-hint>
        {{ 'FORM.huntingDistrictForm.huntingOfficeHint' | translate }}
    </mat-hint>
    </mat-form-field>

    <!-- <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingDistrictForm.erlegungsOrt' | translate}}</mat-label>
        <input formControlName="erlegungsOrt" matInput type="text">
    </mat-form-field> -->

    <div>
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.huntingDistrictForm.huntingTenant' | translate}}</mat-label>
            <mat-select formControlName="huntingTenant" >
                <mat-option *ngFor="let user of allUsersList" [value]="user.identifier">
                    {{user.displayName ?? user.email}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.huntingDistrictForm.feeDebtor' | translate}}</mat-label>
            <mat-select formControlName="feeDebtor" >
                <mat-option *ngFor="let user of allUsersList" [value]="user.identifier">
                    {{user.displayName ?? user.email}}
                </mat-option>
                <!-- <mat-option *ngFor="let user of allUsersList" [value]="{ userId: user.data.identifier, userName:user.data.displayName }">
                    {{user.data.displayName}}
                </mat-option> -->
            </mat-select>
        </mat-form-field>
    </div>

    <!-- extra -->
    <!-- <mat-slide-toggle formControlName="hiTierActive" class="example-margin slide-toggle-text">
        {{'FORM.huntingDistrictForm.hiTierActive' | translate}}
    </mat-slide-toggle> -->

    <div *ngIf="state_Niedersachsen"><!--hiTieractiveValue-->
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.huntingDistrictForm.hitBNR' | translate}}</mat-label>
            <input formControlName="hitBNR" matInput type="text">
        </mat-form-field>

        <mat-form-field class="w-100">
            <mat-label>{{'FORM.huntingDistrictForm.hitMBN' | translate}}</mat-label>
            <input formControlName="hitMBN" matInput type="text">
        </mat-form-field>

        <mat-form-field class="w-100">
            <mat-label>{{'FORM.huntingDistrictForm.hitPIN' | translate}}</mat-label>
            <input formControlName="hitPIN" matInput type="text">
        </mat-form-field>

        <mat-form-field class="w-100">
            <mat-label>{{'FORM.huntingDistrictForm.hitREVAGS' | translate}}</mat-label>
            <input formControlName="hitREVAGS" matInput type="text">
        </mat-form-field>
        
        <p>{{'hiTier_note' | translate}}</p>
    </div>
    
    <app-context-rights-picker formControlName="contextIdRights"></app-context-rights-picker>

</form>
<div class="sticky-bottom">
    <button [disabled]="!canSave" class="first-btn w-100 mt-1" mat-raised-button (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button [disabled]="!canDelete" class="second-btn my-2 w-100" mat-button type="button" (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>